import { RAPORTOR_SECIM_LISTESI } from "../constants/requestUrls";

import { postRequest } from "../request";

const RaportorSecimListesi = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: RAPORTOR_SECIM_LISTESI, data });
}

export default RaportorSecimListesi;